<template>
    <b-card title="Asset Type">
        <b-card-body>
            <slot></slot>

            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'AssetTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [{ key: 'id', label: 'Actions' }, 'name', 'description'],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        user() {
            return this.$store.state.user
        },
        
    },
}
</script>
<style></style>
